import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { GDPRService } from 'src/app/core/services/rulebook';
import { FormControl } from '@angular/forms';
import { UserProfile } from 'src/app/core/models/user';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RulebookMasterFilter } from 'src/app/core/models/rulebook/rulebook-master-filter';
import { LinkedUpdateFilterModel } from 'src/app/core/models/rulebook/linked-update-filter-model';
import { MasterHelper } from 'src/app/core/utilities';
import { ActivatedRoute } from '@angular/router';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-linked-updates-filters',
  templateUrl: './linked-updates-filters.component.html',
  styleUrls: ['./linked-updates-filters.component.scss']
})
export class LinkedUpdatesFiltersComponent implements OnInit {
  @Output() OnFilter = new EventEmitter<any>();
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  rulebookType: string;
  linkUpdateFiltersData: LinkedUpdateFilterModel;
  filterPersistenceKey = 'linkedUpdateFilters';
  user: UserProfile;
  filteredKeywords: Observable<string[]>;
  searchedRegulator: FilterViewModel[] = [];
  masterFilters: RulebookMasterFilter;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchRegulatorCntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();

  @ViewChild('regulatorInput')
  regulatorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('regulatorAutocomplete')
  regulatorAutocomplete!: MatAutocomplete;

  keywords: string[] = [
    'Accounting',
    'Audit',
    'Banking Reform',
    'Basel I',
    'Basel II',
    'Basel III',
    'Capital',
    'Colleges of supervisors',
    'Compensation',
    'Consumer Protection and Financial Innovation',
    'Financial Innovation',
    'Corporate Governance',
    'Credit risk',
    'Deposit Insurance',
    'Financial Benchmarks',
    'Financial Conglomerates',
    'FinTech',
    'Implementation monitoring',
    'Interest Rate Risk',
    'Internal Models',
    'Investment Firms',
    'Large Exposures and structural measures',
    'Leverage Ratio',
    'Liquidity',
    'Liquidity Risk',
    'Macroprudential',
    'Market Infrastructures',
    'Market Risk',
    'Anti Money Laundering',
    'Terrorist financing',
    'Operational Risk',
    'OTC Derivatives',
    'Passporting Supervision of Branches',
    'Supervision of Branches',
    'Payment Services and Electronic Money',
    'Electronic Money',
    'Recovery',
    'Resolution',
    'Crisis Management',
    'Renumeration',
    'Reporting',
    'Risk Analysis and Data',
    'Risk Management',
    'Securitisation',
    'Shadow Banking',
    'Stress Testing',
    'Supervision',
    'Supervisory Reviews',
    'Systemically Important Financial Institutions',
    'Transparency',
    'Disclosure',
    'Insurance',
    'Information Technology and Cyber Security',
    'Pillar 1',
    'Pillar 2',
    'Pillar 3',
    'Governance',
    'Climate',
    'Compensation',
    'Credit Rating Agencies',
    'Cyber Security',
    'Effects of Reform',
    'Benchmarks',
    'Impact Assessment',
    'Legal Entity Identifer',
    'Peer Review',
    'Fund Management',
    'MiFiD',
    'IFRS',
    'Post Trading',
    'Corporate Information',
    'Short Selling',
    'Market Abuse',
    'Market Integrity',
    'Prospectus',
    'Warnings',
    'Trade Repository',
    'Securities Financing Transactions',
    'Transparency and Disclosure'
  ];
  searchedKeywords = this.keywords;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  constructor(private gdprService: GDPRService, private route: ActivatedRoute, private sessionService: SessionService) {
    this.linkUpdateFiltersData = new LinkedUpdateFilterModel();
    this.masterFilters = new RulebookMasterFilter();
    this.user = new UserProfile();
    this.filteredKeywords = this.keyCtrl.valueChanges.pipe(
      startWith(null),
      map((key: string | null) =>
        key ? this._filter(key) : this.keywords.slice()
      )
    );
    this.rulebookType = this.route.snapshot.params.rulebook;

    this.linkUpdateFiltersData.SortKey = 'EffectiveDate';
    this.linkUpdateFiltersData = MasterHelper.parseLinkedUpdateFilters(this.linkUpdateFiltersData) as LinkedUpdateFilterModel;
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as LinkedUpdateFilterModel;
    if (persistFilter) {
      this.linkUpdateFiltersData = persistFilter;
    }
  }

  ngOnInit(): void {
    this.getMasterFilters();
  }
  initFilters(): void {
    this.linkUpdateFiltersData.regulator = [];
    this.linkUpdateFiltersData.searchQuery = [];
    this.linkUpdateFiltersData.fromDate = this.masterFilters.fromDate;
    this.linkUpdateFiltersData.toDate = this.masterFilters.toDate;
    this.searchedRegulator = this.masterFilters.regulator;

    if (this.rulebookType) {
      this.linkUpdateFiltersData.rulebook = this.rulebookType;
    }
    this.linkUpdateFiltersData.SortKey = 'EffectiveDate';
    this.linkUpdateFiltersData = MasterHelper.parseLinkedUpdateFilters(this.linkUpdateFiltersData) as LinkedUpdateFilterModel;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.linkUpdateFiltersData));
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.gdprService.getRulebookFiltersData(this.rulebookType, '').subscribe((result: RulebookMasterFilter) => {
      this.masterFilters = result;
      this.linkUpdateFiltersData.fromDate = this.masterFilters.fromDate;
      this.linkUpdateFiltersData.toDate = this.masterFilters.toDate;
      this.searchedRegulator = this.masterFilters.regulator;
      this.isLoadingFilters = false;

      this.searchRegulatorCntrl.valueChanges.subscribe((data: any) => {
        this.searchedRegulator = data
          ? this.filterRegulator(data)
          : this.masterFilters.geography;
      });
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.keywords.filter(
      fruit => fruit.toLowerCase().indexOf(filterValue) === 0
    );
  }

  filterRegulator(search: string): any {
    return this.searchedRegulator.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addRegulator(event: MatChipInputEvent): void {
    if (!this.regulatorAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        (this.linkUpdateFiltersData.regulator as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchRegulatorCntrl.setValue(null);
    }
  }

  selectedRegulator(event: MatAutocompleteSelectedEvent): void {
    if (this.linkUpdateFiltersData.regulator) {
      this.linkUpdateFiltersData.regulator.push(event.option.viewValue);
    } else {
      this.linkUpdateFiltersData.regulator = [];
      this.linkUpdateFiltersData.regulator.push(event.option.viewValue);
    }
    this.regulatorInput.nativeElement.value = '';
    this.searchRegulatorCntrl.setValue(null);
    this.searchRegulatorCntrl.disable();
    this.searchRegulatorCntrl.enable();
  }

  removeRegulator(status: string): void {
    const index = (this.linkUpdateFiltersData.regulator as string[]).indexOf(status);

    if (index >= 0) {
      (this.linkUpdateFiltersData.regulator as string[]).splice(index, 1);
    }
  }

  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        this.linkUpdateFiltersData.searchQuery.push(value.trim());
      }

      if (input) {
        input.value = '';
      }

      this.keyCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.linkUpdateFiltersData.searchQuery) {
      this.linkUpdateFiltersData.searchQuery.push(event.option.viewValue);
    } else {
      this.linkUpdateFiltersData.searchQuery = [];
      this.linkUpdateFiltersData.searchQuery.push(event.option.viewValue);
    }
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  remove(searchstr: string): void {
    const index = (this.linkUpdateFiltersData.searchQuery as string[]).indexOf(searchstr);

    if (index >= 0) {
      (this.linkUpdateFiltersData.searchQuery as string[]).splice(index, 1);
    }
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  TriggerAction(): void {
    this.linkUpdateFiltersData = MasterHelper.parseLinkedUpdateFilters(this.linkUpdateFiltersData) as LinkedUpdateFilterModel;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.linkUpdateFiltersData));
    this.OnFilter.emit(this.linkUpdateFiltersData);
  }
}
